import React from 'react';
import Popover from './Popover';
import ArmorAvatar from './ArmorAvatar';
import sprites from '../data/armorSprites.json';
import { stageOfLevel } from '../utils/progress';

const nfEn = new Intl.NumberFormat('en-GB');

// Ranglisten efter XP. Kun level, trin og XP: aldrig timer eller bonus.
export default function LeaderboardPopover({ entries, year, onClose }) {
  let body;
  if (entries === null) body = <div style={{ fontSize: 12, color: 'rgba(255,255,255,.6)' }}>The leaderboard is not available right now.</div>;
  else if (!entries.length) body = <div style={{ fontSize: 12, color: 'rgba(255,255,255,.6)' }}>Nobody is on the board yet. Log some time and you will show up.</div>;
  else {
    body = (
      <ol className="flex flex-col overflow-y-auto" style={{ gap: 2, maxHeight: 360 }}>
        {entries.map((e, i) => {
          const stage = stageOfLevel(e.level);
          return (
            <li key={`${e.name}-${i}`} className="flex items-center" style={{ gap: 10, padding: '4px 10px', borderRadius: 6, background: e.me ? '#111e2e' : 'transparent' }}>
              <span className="font-bold tabular-nums" style={{ width: 22, fontSize: 12, color: e.me ? '#FF7800' : 'rgba(255,255,255,.6)' }}>#{i + 1}</span>
              <div className="flex-shrink-0"><ArmorAvatar stage={stage} cell={1.5} /></div>
              <div className="flex-1 min-w-0 flex flex-col">
                <span className="font-bold truncate" style={{ fontSize: 12, lineHeight: '16px' }}>{e.name}{e.me ? ' (you)' : ''}</span>
                <span style={{ fontSize: 10, lineHeight: '12px', color: 'rgba(255,255,255,.5)' }}>{sprites.stages[stage - 1].name}</span>
              </div>
              <span className="font-bold tabular-nums" style={{ fontSize: 12 }}>Lvl {e.level}</span>
              <span className="tabular-nums text-right" style={{ width: 84, fontSize: 11, color: 'rgba(255,255,255,.7)' }}>
                {e.xp !== undefined ? `${nfEn.format(e.xp)} XP` : `${e.pct.toFixed(1)}%`}
              </span>
            </li>
          );
        })}
      </ol>
    );
  }

  return (
    <Popover title={`Leaderboard · ${year}`} onClose={onClose} width={440} left={0} caretLeft={90}>
      {body}
      <div style={{ marginTop: 10, fontSize: 10, color: 'rgba(255,255,255,.45)' }}>Ranked by XP only. Hours and bonus are private.</div>
    </Popover>
  );
}
